import { MenuItem, Typography } from '@mui/material';

import { CheckmarkIcon } from '@/icons';

export const ToggleableOption = ({
  label,
  isSelected,
  onClick,
  startIcon,
}: {
  label: string;
  isSelected: boolean;
  onClick: (...args: any) => void;
  startIcon?: React.ReactNode;
}) => (
  <MenuItem
    sx={{
      borderRadius: 2,
      bgcolor: isSelected ? 'secondary.medium' : 'grey50',
      minHeight: '45px !important',
      px: 2,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      overflow: 'hidden',
      textWrap: 'wrap',
      cursor: 'pointer',
      '&:hover': {
        bgcolor: 'secondary.light',
      },
    }}
    onClick={onClick}>
    {startIcon}
    <Typography
      variant="body3SemiBold"
      color="text.primary"
      sx={{
        mr: 'auto',
        lineHeight: 1.2,
      }}>
      {label}
    </Typography>
    {isSelected && (
      <CheckmarkIcon sx={{ width: 18, height: 18, color: 'secondary.main' }} />
    )}
  </MenuItem>
);
